/** Service Desk console: Mga Ulat sa Serbisyo (C16, SD-S1-48). Ang mga kahulugan sa "i" ay ang salita ng mockup. */
export const serviceReports = {
  subtitle: "{{period}} ({{zone}}){{compare}}. May talahanayan at CSV export ang bawat chart.",
  subtitleCompare: ", ikinumpara sa nakaraang {{days}} araw",
  refreshed: "Na-update ang mga numero {{time}}",
  notRefreshed: "Inihahanda sa background ang mga numero; lalabas ang mga ito pagkatapos ng unang pagproseso sa gabi.",
  controls: {
    group: "Panahon ng ulat",
    range: "Saklaw ng petsa",
    from: "Mula",
    to: "Hanggang",
    compare: "Ikumpara sa nakaraang {{days}} araw",
    presets: { "7d": "Nakaraang 7 araw", "30d": "Nakaraang 30 araw", "90d": "Nakaraang 90 araw", month: "Ngayong buwan", custom: "Sariling saklaw" },
    errorOrder: "Mas maaga ang huling petsa kaysa sa simula.",
    errorLong: "Hanggang {{days}} araw lang ang saklaw ng ulat.",
  },
  tabs: { label: "Mga seksyon ng ulat", overview: "Pangkalahatan", sla: "SLA", teams: "Mga team at agent", agents: "Mga agent", "agent-chats": "Mga chat ng agent", orgs: "Mga organisasyon", csat: "CSAT", deflection: "Deflection" },
  export: {
    summary: "I-export ang buod",
    summaryFile: "Na-save bilang {{file}} ang buod ng {{count}} numero.",
    chart: "I-download ang {{title}} bilang CSV",
    chartDone: "Na-save ang {{file}}.",
    failed: "Hindi namin ma-export ang ulat. Subukan ulit.",
    columns: { metric: "Sukatan", value: "Halaga", previous: "Nakaraang panahon", change: "Pagbabago" },
  },
  chart: { viewTable: "Tingnan bilang talahanayan", viewChart: "Tingnan bilang chart", tableOf: "{{title}} bilang talahanayan", noData: "Walang datos sa panahong ito.", definition: "Ano ang ibig sabihin ng {{title}}?" },
  unit: { min: "{{value}} min", hour: "{{value}} oras", day: "{{value}} araw", pts: "{{value}} pts" },
  delta: { vs: "kumpara sa nakaraang panahon", noPrevious: "Walang nakaraang numero", flat: "Walang pagbabago", up: "Tumaas ng {{value}}", down: "Bumaba ng {{value}}" },
  noValue: "—",
  noValueLabel: "Wala pang datos",
  kpi: {
    label: "Mga pangunahing numero",
    created: "Mga ticket na nagawa",
    backlog: "Bukas na backlog (ngayon)",
    frt: "Median ng unang tugon",
    ttr: "Median ng resolusyon (oras ng negosyo)",
    slaFirst: "Pagsunod sa SLA: unang tugon",
    slaRes: "Pagsunod sa SLA: resolusyon",
    csat: "CSAT",
    csatSub: "{{responses}} sagot, {{rate}} response rate",
    csatNone: "Walang rating sa panahong ito",
    reopen: "Rate ng muling pagbubukas",
    deflection: "Tapat na deflection",
    deflectionSub: "{{deflected}} sa {{eligible}} usapang may alalahanin",
    intake: "Pagkumpleto ng intake",
    intakeSub: "{{submitted}} sa {{started}} intake",
  },
  def: {
    created: "Mga ticket na nagawa sa panahon, ayon sa uri, channel, pinagmulan, organisasyon, priyoridad o team.",
    backlog: "Mga bukas na ticket (bago, bukas, naghihintay, naka-hold) sa pagtatapos ng panahon, ayon sa edad: 0–1 d, 1–3 d, 3–7 d, 7–30 d at higit sa 30 d.",
    frt: "Mga minuto ng oras ng negosyo mula sa paggawa ng ticket hanggang sa unang pampublikong tugon ng staff (hindi system, hindi AI). Median at p90.",
    ttr: "Mga minuto ng oras ng negosyo mula sa paggawa hanggang sa na-resolve, bawas ang oras na naka-pause. Median at p90.",
    slaFirst: "Pagsunod sa SLA = natugunan ÷ (natugunan + nalabag) para sa unang tugon.",
    slaRes: "Pagsunod sa SLA = natugunan ÷ (natugunan + nalabag) para sa resolusyon.",
    csat: "Karaniwang marka, response rate, bahagi ng 4 at 5 bituin, at ang mga ibinigay na dahilan.",
    reopen: "Mga ticket na nabuksan ulit nang hindi bababa sa isang beses ÷ mga ticket na na-resolve.",
    deflection: "Tapat na deflection: malinaw na “Ito ang sagot”, o walang ticket sa loob ng 24 oras matapos ang sagot na batay sa knowledge base sa daloy ng alalahanin, ÷ mga usapang may alalahanin.",
    intake: "Mga ticket na naisumite mula sa summary card ng assistant na hinati sa mga intake na sinimulan.",
  },
  overview: {
    perWeek: { title: "Mga ticket na nagawa kada linggo", sub: "{{period}}, sa mga linggong binibilang mula sa unang araw", seriesNow: "Panahong ito", seriesBefore: "Nakaraang panahon", week: "Linggo ng", partial: "Hindi buo ang huling {{unit}} ({{from}} hanggang {{to}}).", unitWeek: "linggo" },
    perDay: { title: "Mga ticket na nagawa kada araw", sub: "{{period}}", seriesNow: "Panahong ito", seriesBefore: "Nakaraang panahon", week: "Araw" },
    channel: { title: "Mga ticket ayon sa channel", sub: "{{period}}", column: "Channel", count: "Mga ticket" },
    age: { title: "Bukas na backlog ayon sa edad", sub: "{{count}} ang bukas ngayon", column: "Edad", count: "Mga bukas na ticket", b0_1: "0–1 d", b1_3: "1–3 d", b3_7: "3–7 d", b7_30: "7–30 d", b30p: "Higit sa 30 d" },
    type: { title: "Mga ticket ayon sa uri", sub: "{{period}}", column: "Uri", count: "Mga ticket" },
  },
  sla: {
    metrics: { title: "Pagsunod ayon sa target", sub: "Natugunan ÷ (natugunan + nalabag) sa panahon", column: "Target", compliance: "Pagsunod", met: "Natugunan", breached: "Nalabag" },
    metricNames: { first_response: "Unang tugon", next_response: "Susunod na tugon", resolution: "Resolusyon", onsite_response: "Tugon sa lugar" },
    weekly: { title: "Pagsunod kada linggo", sub: "Unang tugon at resolusyon", column: "Linggo ng", first: "Unang tugon %", res: "Resolusyon %", note: "Ang panahong walang nasukat na target ay inuulit ang nauna; guhit ang makikita sa talahanayan." },
    daily: { title: "Pagsunod kada araw", sub: "Unang tugon at resolusyon", column: "Araw", first: "Unang tugon %", res: "Resolusyon %", note: "Ang panahong walang nasukat na target ay inuulit ang nauna; guhit ang makikita sa talahanayan." },
    policy: { title: "Ayon sa patakaran", sub: "{{period}}", column: "Patakaran", none: "Walang patakaran" },
    priority: { title: "Ayon sa priyoridad", sub: "{{period}}", column: "Priyoridad" },
    live: {
      title: "Nalabag o nanganganib ngayon",
      sub: "Live mula sa mga ticket",
      caption: "Mga ticket na nalabag o nanganganib",
      ticket: "Ticket",
      organisation: "Organisasyon",
      priority: "Priyoridad",
      sla: "SLA",
      assignee: "Nakatalaga",
      unassigned: "Walang nakatalaga",
      emptyTitle: "Walang nalabag o nanganganib",
      emptyBody: "Nasa loob ng SLA ang bawat bukas na ticket.",
      error: "Hindi namin mabasa ang mga live na ticket.",
    },
    settingsHint: "Ine-edit ang mga patakaran at kalendaryo sa",
    settingsLink: "Settings ng Serbisyo",
  },
  teams: {
    byTeam: { title: "Mga ticket ayon sa team", sub: "{{period}}", column: "Team", tickets: "Mga ticket", frt: "Median ng unang tugon", sla: "SLA" },
    slaTeam: { title: "Pagsunod sa SLA ayon sa team", sub: "Unang tugon, resolusyon at iba pa, natugunan ÷ (natugunan + nalabag)", column: "Team", sla: "SLA %" },
    agents: {
      title: "Mga agent at engineer",
      sub: "Mga bukas na ticket ngayon at mga rating sa panahon",
      caption: "Mga ticket ayon sa agent",
      person: "Tao",
      open: "Bukas ngayon",
      csat: "CSAT",
      responses: "Mga sagot",
      total: "Kabuuan",
      empty: "Walang agent na may bukas na ticket o rating sa panahong ito.",
    },
    noTeam: "Walang team",
    noAssignee: "Walang nakatalaga",
  },
  orgs: {
    tickets: { title: "Mga ticket ayon sa organisasyon", sub: "{{period}}; walang organisasyon ang mga bisita at hindi matukoy na nagpadala", column: "Organisasyon", count: "Mga ticket" },
    health: {
      title: "Kalagayan ng organisasyon",
      sub: "Mga ticket, bilis, SLA at kasiyahan sa panahon",
      caption: "Kalagayan ng organisasyon",
      organisation: "Organisasyon",
      tickets: "Mga ticket",
      resolution: "Median ng resolusyon",
      sla: "SLA",
      csat: "CSAT",
      none: "Walang organisasyon",
    },
  },
  csat: {
    response: { title: "Response rate", sub: "{{responses}} sa {{sent}} survey ang nasagot", answered: "Sumagot", unanswered: "Walang sagot", column: "Grupo", share: "Bahagi", center: "{{count}} sagot" },
    positive: { title: "Mga positibong rating", sub: "4 at 5 bituin sa {{count}} rating", positive: "4–5 bituin", other: "1–3 bituin", column: "Grupo", count: "Mga sagot", center: "{{count}} rating" },
    reasons: { title: "Mga dahilan ng 1 hanggang 3 bituin", sub: "Ayon sa pinili ng kliyente", column: "Dahilan", count: "Mga sagot", empty: "Walang ibinigay na dahilan sa panahong ito." },
    settings: "Settings ng CSAT",
  },
  deflection: {
    funnel: {
      title: "Mula alalahanin hanggang ticket",
      sub: "{{period}}",
      column: "Hakbang",
      count: "Mga usapan",
      started: "Mga usapang may alalahanin",
      deflected: "Naayos nang walang ticket",
      open: "Naghihintay ng ticket sa loob ng 24 oras",
      ticket: "Naging ticket",
    },
    intake: { title: "Pagkumpleto ng intake", sub: "Mga summary card na naisumite ÷ intake na sinimulan", submitted: "Naisumite", abandoned: "Iniwan", centerSub: "{{submitted}} sa {{started}}", column: "Kinalabasan", share: "Bahagi" },
    note: "Ang “tapat” ay nangangahulugang batay sa knowledge base mo ang sagot at sinabi ng kliyenteng ito ang solusyon, o walang ticket na sumunod sa loob ng 24 oras.",
  },
  states: {
    emptyTitle: "Walang ticket sa panahong ito",
    emptyBody: "Pumili ng mas malawak na saklaw ng petsa. Napupuno ang mga ulat habang may dumarating na ticket.",
    emptyAction: "Gamitin ang karaniwang panahon",
    errorTitle: "Hindi namin nabuo ang ulat",
    errorBody: "Walang problema ang mga ticket mo. Tingnan ang koneksyon at subukan ulit.",
    retry: "Subukan ulit",
    loading: "Nilo-load ang ulat",
    chartError: "Hindi namin ma-load ang chart na ito.",
  },
} as const;
